import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Legal.css';

const PrivacyPolicy = () => (
  <div className="legal-page">
    <Header />
    <div className="legal-hero">
      <h1>Privacy Policy</h1>
      <p>Last updated: 02 - May - 2026</p>
    </div>
    <div className="legal-content">
      <section>
        <h2>1. Information We Collect</h2>
        <p>We collect information you provide when contacting us, including your name, email address, phone number, and service inquiries. We also collect newsletter subscription emails and contact form submissions.</p>
      </section>
      <section>
        <h2>2. How We Use Your Information</h2>
        <p>Your information is used to respond to inquiries, provide quotes, deliver our services, send newsletters (if subscribed), and improve our customer experience.</p>
      </section>
      <section>
        <h2>3. Data Protection</h2>
        <p>We implement security measures to protect your personal information. Your data is stored securely and only accessible to authorized personnel.</p>
      </section>
      <section>
        <h2>4. Cookies</h2>
        <p>Our website uses cookies to enhance your browsing experience. You can control cookie settings through your browser preferences.</p>
      </section>
      <section>
        <h2>5. Third-Party Services</h2>
        <p>We may use third-party services for analytics and website functionality. These services have their own privacy policies.</p>
      </section>
      <section>
        <h2>6. Contact Us</h2>
        <p>For privacy-related inquiries, contact us at <a href="mailto:info@musaelectricalkenya.co.ke">info@musaelectricalkenya.co.ke</a> or call <a href="tel:0796049254">0796049254</a>.</p>
      </section>
    </div>
    <Footer />
  </div>
);

export default PrivacyPolicy;
